import { useNavigate, useSearchParams } from "react-router-dom";
import Error from "../../assets/Login/payment-error.jpg";
import { useEffect } from "react";
import showToast from "../../utils/toastNotifications";

function PaymentErrorPage() {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const error = searchParams.get("message") || null;

    useEffect(() => {
        if(error && error?.toString()?.length > 0){
            showToast("error", error || "Error Occurred")
        }
    }, [])

    const goBack = () => {
        navigate("/calculation");
    };

    return (
        <div className="h-screen w-full min-w-[340px]">
            <main className="font-inter flex flex-col lg:flex-row items-center justify-center h-screen w-full">
                <img src={Error} alt="" className="w-[600px] h-auto"></img>
                <div className="flex flex-col items-center justify-center text-center lg:text-start">
                    <h1 className="font-roboto text-primary font-bold text-[50px] md:text-[64px]">
                        Aw Snap!
                    </h1>
                    <p className="font-roboto text-primary font-bold text-[28px] text-center px-10">
                        Your Payment Proccess Failed Due to an Unexpected Error.
                    </p>
                    <div className="flex flex-col text-center md:flex-row mt-10">
                        <p className="font-inter text-[16px] text-gray">
                            Couldn't find that.{" "}
                        </p>
                        <button
                            onClick={goBack}
                            className="underline text-primary cursor-pointer ml-2"
                        >
                            Safely Go Back?{" "}
                        </button>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default PaymentErrorPage;
